export default function ({ app }) {
	let openedFromApp = false
	try {
		openedFromApp = new URL(document.referrer).origin === window.location.origin
	} catch (error) {
		// Missing or invalid referrers cannot establish an in-app card visit.
	}

	app.router.beforeEach((to, from, next) => {
		if (
			to.query.apply_source === undefined ||
			from.matched.length > 0 ||
			openedFromApp
		) {
			return next()
		}

		// A copied card URL carries the sender's source. Only SPA navigation or
		// a same-origin referrer (including a card opened in a new tab) owns it.
		const { apply_source, ...query } = to.query
		next({ path: to.path, query, hash: to.hash, replace: true })
	})
}
